import FComponentsLib from '@freelog/components-lib';
// import './index.less';
import { Popover } from 'antd';
import FPageFooter from '@/components/FPageFooter';

interface FFooterProps {
  style?: React.CSSProperties;
}

function FFooter({ style = {} }: FFooterProps) {
  return (
    <div
      // className='footer flex-column align-center w-100x'
      style={{
        zIndex: 20,
        backgroundColor: '#FAFBFC',
        paddingTop: '70px',
        display: 'flex',
        flexFlow: 'column',
        position: 'relative',
        alignItems: 'center',
        width: '100%',
        ...style,
      }}
    >
      <i
        // className={'freelog fl-icon-feather bottom-logo'}
        className={'freelog fl-icon-feather'}
        style={{
          marginBottom: '30px',
          fontSize: '40px',
          color: '#2784ff',
        }}
      />
      <div
        // className='title'
        style={{
          fontSize: '20px',
          fontWeight: 600,
          color: '#222222',
          lineHeight: '26px',
          marginBottom: '30px',
        }}
      >
        Freelog，专业免费的资源发行和运营平台
      </div>
      <div
        //  className='title2'
        style={{
          fontSize: '14px',
          fontWeight: 400,
          color: '#222',
          lineHeight: '20px',
          opacity: 0.4,
          marginBottom: '82px',
        }}
      >
        支持图片、小说、游戏、漫画、视频、音乐、主题、插件等各类型资源快速变现
      </div>
      <FPageFooter />
    </div>
  );
}

export default FFooter;
